module.exports = __webpack_public_path__ + "img/bg-left.37b46dcc.png";